export default __webpack_public_path__ + "static/media/Cheryl 9781408309155.9a09c791.jpg";